import { Pipe, PipeTransform } from '@angular/core';
import { DataTransformationService } from '@app/common/data-transformation.service';

@Pipe({
  name: 'formatAge'
})
export class FormatAgePipe implements PipeTransform {
  constructor(private dataTransformationService: DataTransformationService) {}

  transform(patAge): string {
    return this.dataTransformationService.getFormattedPatAge(patAge);
  }
}
